<template>
	<div>
		<div class="homes" ref="homes">
			<div class="homesheader">
				<div class="row">
					<!-- BEGIN col-3 -->
					<div class="col-xl-3 col-md-6">
						<div class="widget widget-stats bg-blue">
							<div class="stats-icon"><i class="fa fa-desktop"></i></div>
							<div class="stats-info">
								<h4>实训室总数</h4>
								<p><numbergrow :value="cardtrain.trainCount"></numbergrow></p>
							</div>
							<div class="stats-link" @click="gotrains()">
								<a href="javascript:;">
									查看详细&nbsp;
									<i class="fa fa-arrow-alt-circle-right"></i>
								</a>
							</div>
						</div>
					</div>
					<!-- END col-3 -->
					<!-- BEGIN col-3 -->
					<div class="col-xl-3 col-md-6">
						<div class="widget widget-stats bg-info">
							<div class="stats-icon"><i class="fa fa-link"></i></div>
							<div class="stats-info">
								<h4>实训设备总数</h4>
								<p><numbergrow :value="cardtrain.trainECount"></numbergrow></p>
							</div>
							<div class="stats-link" @click="gotrainsb()">
								<a href="javascript:;">
									查看详细
									<i class="fa fa-arrow-alt-circle-right"></i>
								</a>
							</div>
						</div>
					</div>
					<!-- END col-3 -->
					<!-- BEGIN col-3 -->
					<div class="col-xl-3 col-md-6">
						<div class="widget widget-stats bg-orange">
							<div class="stats-icon"><i class="fa fa-users"></i></div>
							<div class="stats-info">
								<h4>累计实训人数</h4>
								<p><numbergrow :value="cardtrain.trainPCount"></numbergrow></p>
							</div>
							<div class="stats-link" @click="gotrainnum()">
								<a href="javascript:;">
									查看详细
									<i class="fa fa-arrow-alt-circle-right"></i>
								</a>
							</div>
						</div>
					</div>
					<!-- END col-3 -->
					<!-- BEGIN col-3 -->
					<div class="col-xl-3 col-md-6">
						<div class="widget widget-stats bg-red">
							<div class="stats-icon"><i class="fa fa-clock"></i></div>
							<div class="stats-info">
								<h4>累计实训时间(小时)</h4>
								<p>
									<!-- <numbergrow :value="cardtrain.trainTime"></numbergrow> -->
									{{ cardtrain.trainTime }}
								</p>
							</div>
							<div class="stats-link"><a href="javascript:;">&nbsp;</a></div>
						</div>
					</div>
					<!-- END col-3 -->
				</div>
			</div>
			<div class="homeechtes">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="lefttx">
							<div class="title">
								<p class="titlefont">{{ yearrvalues }}年实训人数统计</p>
								<div class="block"><el-date-picker @change="chengesdata()" v-model="values" type="year" placeholder="选择年"></el-date-picker></div>
							</div>
							<el-empty v-if="!ispeoples" :image-size="200" description="暂无实训人数,请尽快完成实训"></el-empty>
							<div style="width: 100%;overflow: hidden;" v-show="ispeoples"><histogram datetype="linear"></histogram></div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="tightsx">
							<div class="title"><p class="titlefont">实训设备状态统计（台）</p></div>
							<histogram :trainchats="peoplenums" datetype="pie"></histogram>
							<div class="gramlable">
								<div class="col-xs-12 col-sm-3 col-lg-6">
									<p style="color: #ccc;font-size: 1rem;">维修中</p>
									<span class="clice"></span>
									<p>
										<span>{{ peoplenums.OfflineCount }}</span>
									</p>
								</div>
								<div class="col-xs-12 col-sm-3 col-lg-6">
									<p style="color: #ccc;font-size: 1rem;">空闲中</p>
									<span class="clice" style="background-color: #5470C6;"></span>
									<p>{{ peoplenums.IdleCount }}</p>
								</div>
								<div class="col-xs-12 col-sm-3 col-lg-6">
									<p style="color: #ccc;font-size: 1rem;">离线中</p>
									<span class="clice" style="background-color: #FAC858;"></span>
									<p>{{ peoplenums.RepairCount }}</p>
								</div>
								<div class="col-xs-12 col-sm-3 col-lg-6">
									<p style="color: #ccc;font-size: 1rem;">使用中</p>
									<span class="clice" style="background-color: #91CC75;"></span>
									<p>
										<span></span>
										{{ peoplenums.UsingCount }}
									</p>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="useruses">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="nowusers">
							<div class="title"><p class="titlefont">最近5天设备使用率情况分析</p></div>
							<el-empty v-if="!isfivesa" description="暂无实训使用设备,请尽快安排实训"></el-empty>

							<ul class="qkfx" v-if="isfivesa">
								<li>
									<span></span>
									<p class="whsix">日期</p>
									<p class="whsix">设备使用率（%）</p>
									<p class="whsix">值</p>
								</li>
								<li v-for="(item, index) in proporn" :key="index">
									<span class="el-icon-share" style="color: #5E86CE;"></span>
									<p class="whsix">{{ item.date }}</p>
									<div class="whsix">
										<el-progress v-if="!isNaN(item.usage)" :show-text="false" :percentage="item.usage" :color="customColorMethod"></el-progress>
									</div>
									<p class="whsix">{{ item.usage }}%</p>
								</li>
							</ul>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
						<div class="nowfurl">
							<div class="title"><p class="titlefont">最近5天实训预约人数占比统计</p></div>
							<el-empty v-if="!foursshow" description="最近4天未进行实训,请引导学生进入实训"></el-empty>

							<div v-show="foursshow"><histogram datetype="pie1"></histogram></div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';
import histogram from '@/components/chats/histogram.vue';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import $ from 'jquery';
import { getTrainSTA, getTrainEquipmentStatusSTA, GetTrainUsageSTA, getTrainAppointmentCountSTA, getTrainAnnualSTA } from '@/request/api/home.js';

export default {
	data() {
		return {
			isnums: 0,
			chart1: {},
			chart2: {},
			chart3: {},
			ispeoples: true,
			numslist: [],
			foursshow: true,
			// 进度条颜色
			percentage: 63.5,
			// 时间选择器
			values: '2022',
			yearrvalues: '2022',
			pickerOptions: {},
			phones: '',
			// 四大边框
			cardtrain: {},
			// 三大图表
			peoplenums: {},
			sbtrainchar: {},
			numfour: {},
			// 进度条
			proporn: [],
			// option
			option: {
				color: [
					{
						type: this.datetypes,
						x: 1,
						y: 0,
						x2: 1,
						y2: 1,
						colorStops: [
							{
								offset: 0,
								color: '#336BB5'
							}, // 设置颜色渐变
							{
								offset: 1,
								color: '#49968D'
							}
						]
					}
				],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						axisTick: {
							alignWithLabel: true
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLabel: { formatter: '{value} 人' }
					}
				],
				series: [
					{
						name: '实训人数统计',
						type: 'bar',
						barWidth: '60%',
						data: [500, 700, 820, 900, 920, 1390, 900, 700, 800, 600, 400, 500]
					}
				]
			},

			option1: {
				legend: {
					bottom: '0%'
				},
				tooltip: {
					trigger: 'item'
				},
				series: [
					{
						name: '实时设备状态统计',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [
							{
								value: 742,
								name: '空闲中',
								itemStyle: {
									color: '#5470C6'
								}
							},
							{
								value: 2721,
								name: '使用中',
								itemStyle: {
									color: '#91CC75'
								}
							},
							{
								value: 1000,
								name: '离线中',
								itemStyle: {
									color: '#FAC858'
								}
							},
							{
								value: 1500,
								name: '维修中',
								itemStyle: {
									color: '#EE6666'
								}
							}
						]
					}
				]
			},

			option2: {
				legend: {
					bottom: '30%',
					left: '20%'
				},
				series: [
					{
						width: '100%',
						startAngle: 0, // 饼图的角度
						// hoverAnimation: false, // 取消饼图放大效果
						name: '访问来源',
						type: 'pie',
						radius: ['30%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
							// padding: [0, 2], //文字和图的边距
							rich: {
								formatter: '{b|{b}} {c|{c}}', //图形外文字上下显示
								borderWidth: 30,
								borderRadius: 4,
								a: {
									color: '#333',
									fontSize: 14,
									lineHeight: 30
								},
								b: {
									//name 文字样式
									fontSize: 14,
									lineHeight: 40,
									color: '#CDCDD0'
								},
								c: {
									//value 文字样式
									fontSize: 14,
									lineHeight: 40,
									color: '#63BF6A',
									align: 'center'
								}
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [
							{
								value: 100,
								itemStyle: {
									color: 'transparent' // 透明色
								},
								name: ''
							}
						]
					}
				]
			}
		};
	},
	computed: {
		isfivesa() {
			if (this.proporn.length > 0) {
				return true;
			} else {
				return false;
			}
		}
	},
	beforeCreate() {},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.yearrvalues = new Date().getFullYear();
		this.values = new Date().getFullYear() + '';
		if (!AppOptions.appEmpty) {
			this.gethomesapi();
			this.chats();
		}
	},
	updated() {},
	methods: {
		gotrains() {
			this.$router.push('/device/trainingmange');
		},
		gotrainsb() {
			this.$router.push('/device/trainingmangesb');
		},
		gotrainnum() {
			this.$router.push('/allmanage/orderselete');
		},

		// 更改日期
		chengesdata() {
			// console.log(this.values)
			let date = new Date(this.values);
			let y = date.getFullYear();
			this.yearrvalues = y;
			const timeyear = y;
			// console.log(timeyear)
			this.getyears(timeyear);
		},

		chats() {
			let chart1 = this.$echarts.getInstanceByDom(document.getElementById('sector'));
			if (chart1 == null) {
				chart1 = this.$echarts.init(document.getElementById('sector'));
			}
			let chart2 = this.$echarts.getInstanceByDom(document.getElementById('sxpice'));
			if (chart2 == null) {
				chart2 = this.$echarts.init(document.getElementById('sxpice'));
			}

			let chart3 = this.$echarts.getInstanceByDom(document.getElementById('sxpople'));
			if (chart3 == null) {
				chart3 = this.$echarts.init(document.getElementById('sxpople'));
			}

			this.chart1 = chart1;
			this.chart2 = chart2;
			this.chart3 = chart3;

			window.addEventListener('resize', function() {
				chart1.resize();
				chart2.resize();
				chart3.resize();
			});
		},

		getyears(year = '2022') {
			// 实训人数统计

			let peoplenum = {
				si_guid: localStorage.getItem('siguid'),
				year: year
			};
			getTrainAnnualSTA(peoplenum).then(res => {
				// console.log(res, "实训人数统计")

				if (res.data.data && res.data.data.length > 0) {
					let montedlist = [];
					let numslist = [];
					this.ispeoples = true;

					res.data.data.forEach(item => {
						montedlist.push(item.month + '月');
						numslist.push(item.count);
					});
					this.option.xAxis[0].data = montedlist;
					this.option.series[0].data = numslist;
					// var chart1 = this.$echarts.init(document.getElementById('sector'));

					this.numslist = numslist;
					this.$nextTick(() => {
						this.chart1.setOption(this.option);
					});
				} else {
					this.ispeoples = false;
					// this.$message('暂无数据');
					this.option.xAxis[0].data = [];
					this.option.series[0].data = [];
					// var chart1 = this.$echarts.init(document.getElementById('sector'));
					this.numslist = [];
					this.chart1.setOption(this.option);
				}
			});
		},
		async gethomesapi() {
			let id = localStorage.getItem('siguid');
			await getTrainSTA(id).then(res => {
				// console.log(res, '这里是否会执行两次');
				this.cardtrain = res.data.data;
				// 获取小时和分钟部分
				let wholeHours = Math.floor(res.data.data.trainTime);
				let minutes = (res.data.data.trainTime - wholeHours) * 60;
				// 将小时转换为天、小时和分钟
				let days = Math.floor(wholeHours / 24);
				let remainingHours = Math.floor(wholeHours % 24);
				let remainingMinutes = Math.floor(minutes);
				// this.cardtrain.trainTime = days +""+"日"
				// console.log(days,remainingHours,remainingMinutes,wholeHours,res.data.data.trainTime,"时间")
			});
			// 实训人数统计
			let peoplenum = {
				si_guid: localStorage.getItem('siguid'),
				year: this.values
			};
			await getTrainAnnualSTA(peoplenum).then(res => {
				// console.log(res, "实训人数统计")
				if (res.data.data && res.data.data.length > 0) {
					let montedlist = [];
					let numslist = [];
					res.data.data.forEach(item => {
						montedlist.push(item.month + '月');
						numslist.push(item.count);
					});
					this.option.xAxis[0].data = montedlist;
					this.option.series[0].data = numslist;
					// var chart1 = this.$echarts.init(document.getElementById('sector'));
					this.$nextTick(() => {
						// this.chart1.clear();
						this.ispeoples = true;
						this.chart1.setOption(this.option);
						this.chart1.resize();
					});
				} else {
					this.option.xAxis[0].data = [];
					this.option.series[0].data = [];
					// var chart1 = this.$echarts.init(document.getElementById('sector'));

					this.$nextTick(() => {
						// this.chart1.clear();
						this.ispeoples = false;
						this.chart1.setOption(this.option);

						this.chart1.resize();
					});
					// this.$message('暂无数据');
				}
			});

			//
			await getTrainEquipmentStatusSTA(id).then(res => {
				// console.log(res, "实训设备统计")
				if (res.data.data) {
					this.peoplenums = res.data.data;
					this.option1.series[0].data[0].value = this.peoplenums.IdleCount;
					this.option1.series[0].data[1].value = this.peoplenums.UsingCount;
					this.option1.series[0].data[2].value = this.peoplenums.RepairCount;
					this.option1.series[0].data[3].value = this.peoplenums.OfflineCount;
					// let chart2 = this.$echarts.init(document.getElementById("sxpice"))
					this.chart2.setOption(this.option1);
				} else {
					// this.$message('暂无数据');
				}
			});

			// 最近5天设备使用率
			let UsageSTA = {
				si_guid: id,
				time: '5'
			};
			await GetTrainUsageSTA(UsageSTA).then(res => {
				// console.log(res, "最近5天设备使用率")
				if (res.data.data && res.data.data.length > 0) {
					this.proporn = res.data.data;
					this.proporn.forEach(item => {
						item.usage = parseInt(item.usage);
					});

					// this.proporn[2].usage = 200
				} else {
					this.proporn = [];
					// this.$message('暂无数据');
				}
			});

			// 最近4天实训
			let Appointment = {
				si_guid: id,
				time: 5
			};
			await getTrainAppointmentCountSTA(Appointment).then(res => {
				// console.log(res.data, "五天占比")

				let serchlist = [];
				if (res.data.data && res.data.data.length > 0) {
					res.data.data.forEach(item => {
						let serchars = {};
						serchars.value = Math.round(item.usage);
						serchars.name = item.date + '人数占比' + Math.round(item.usage) + '%';
						// let itemStyle = {}
						// itemStyle.color = "rgb(0,102,80)"
						// serchars.itemStyle = itemStyle
						// console.log(serchars.itemStyle.color)
						serchlist.push(serchars);
					});
					// console.log("五天占比",serchlist,res.data.data)
					serchlist.forEach(item => {
						this.option2.series[0].data.push(item);
					});

					if (res.data.data.length < 3) {
						this.option2.legend.left = 'center';
					}

					this.foursshow = true;
					// var chart3 = this.$echarts.init(document.getElementById("sxpople"))
					this.chart3.clear();
					this.chart3.setOption(this.option2);
					//监听，根据视口变化动态从新渲染表格
					this.chart3.resize();
					this.$nextTick(() => {
						this.chats();
					});
				} else {
					this.foursshow = false;

					this.$nextTick(() => {
						this.chats();
					});
					// this.$message('暂无数据');
				}
			});
		},

		changewidth() {
			var that = this;
			// console.log(window.)
			if (window.screen.width > 749) {
				// console.log("pv")
				that.phones = true;
			} else {
				// console.log("app")
				that.phones = false;
			}
		},
		customColorMethod(percentage) {
			if (percentage < 40) {
				return '#f56c6c';
			} else if (percentage > 40 && percentage < 60) {
				return '#e6a23c';
			} else if (percentage > 60 && percentage < 80) {
				return '#1989fa';
			} else {
				return '#5cb87a';
			}
		}
	},
	components: {
		histogram,
		numbergrow
	}
};
</script>

<style scoped lang="less">
// .lefttx /deep/ div{
// 	color: #000;
// }

@media only screen and (min-width: 768px) {
	.el-col-sm-24:last-child {
		margin-bottom: 1rem;
	}
}

.qkfx {
	width: 90%;
	box-sizing: border-box;
	text-align: center;
	padding: 3vh 0;
	margin: 0 auto;

	li {
		display: flex;
		align-items: center;

		span {
			margin: 10px 1.8rem;
		}

		.whsix {
			// padding: 0 10px;
			width: 25vw;
		}
	}

	li:first-child {
		height: 3rem;
		height: 3rem;
	}
}

.title {
	display: flex;
	align-items: center;
	height: 3rem;
	border-bottom: 1px solid #eeeeee;
	justify-content: space-between;

	.titlefont {
		// color: #000;
		font-size: 1rem;
		margin-left: 1rem;
		font-weight: 600;
	}
}

.useruses {
	// display: flex;
	// align-items: center;
	// flex-wrap: wrap;

	.nowusers {
		border-right: 16px solid #eff2fa;
		box-sizing: border-box;
		border-top-right-radius: 10px;
		// margin: 1rem 0;
	}

	.nowfurl {
		// margin-top: 1rem;
	}

	.nowusers {
		margin-bottom: 1rem;
	}

	.nowfurl,
	.nowusers {
		border-radius: 10px;
		background: #fff;
		height: 20rem;
		border: 0 !important;
		// margin: 0 !important;
	}
}

.homesheader {
	margin: 2vh 0 -4vh 0;

	.stats-info {
		p {
			/deep/ .number-grow {
				font-size: 1.8rem;
				color: #fff;
			}
		}
	}
}

.homeechtes {
	// display: flex;
	// align-items: center;
	// flex-wrap: wrap;
	// margin: 1rem 0 0;
	padding: 1rem 0 0;

	.title {
		display: flex;
		align-items: center;
		height: 3rem;
		border-bottom: 1px solid #eeeeee;
		justify-content: space-between;

		/deep/ .el-date-editor .el-range-separator {
			padding: 0 !important;
			line-height: 19px !important;
			font-size: 0.4rem;
		}

		/deep/ .el-range-editor.el-input__inner {
			height: 1.2rem;
			padding: 0 !important;
			border-color: transparent !important;
		}

		/deep/ .el-date-editor .el-range__icon {
			line-height: 19px !important;
		}

		/deep/ .el-date-editor .el-range__close-icon {
			line-height: 19px !important;
		}

		.block {
			margin-right: 1rem;
		}
	}

	.lefttx {
		height: 30rem;
		// border: 1px solid;
		// margin-right: 1vw;
		background: #fff;
		// border-right: 1vw solid #EFF2FA;
		border-radius: 5px;
		box-sizing: border-box;
		margin: 1rem 0 0;
	}

	.tightsx {
		height: 30rem;
		// border: 1px solid;
		background: #fff;
		border-radius: 5px;
		margin-top: 1rem;

		.gramlable {
			border-top: 1px solid #ccc;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			-ms-flex-wrap: wrap;
			flex-wrap: wrap;
			/* padding: 1rem 6rem; */
			padding-left: 9%;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;

			div {
				// margin-left: 1rem;
				margin-top: 1rem;
				display: flex;
				align-items: center;
				justify-content: flex-start;

				.clice {
					display: block;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin: 0 0.4rem 0 1.2rem;
					background: #ff3807;
				}
			}
		}
	}
}
</style>
